/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const asterisk = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M17.7 11.4h-4.6l3-3.1-.7-.6-2.9 2.9V6.5h-1v4.2l-2.9-3-.7.6 2.9 3.1H6.5v1h4.3l-3.2 3.3.8.6 3.1-3.2.1 4.6h1l-.1-4.6 3.1 3.2.8-.6-3.2-3.3h4.5z" />
	</SVG>
);

export default asterisk;
